// src/string.ts
var toUpperCase = (str) => str.toUpperCase();
var toLowerCase = (str) => str.toLowerCase();
var split = (str, delimiter) => str.split(delimiter);
var capitalize = (str) => `${str.charAt(0).toUpperCase()}${str.slice(1)}`;
var uncapitalize = (str) => `${str.charAt(0).toLowerCase()}${str.slice(1)}`;
var isHex = (str) => /^0x[\da-f]+$/i.test(str);
export {
  capitalize,
  isHex,
  split,
  toLowerCase,
  toUpperCase,
  uncapitalize
};
